import React from 'react';
import { Typography } from 'antd';
import {
  OfferedItemDetails,
  ProjectHomeIdentifiersProps,
} from './OfferedItemDetails';
import { OfferedItemLookup } from './useOfferedItemsDataSource';

const { Title } = Typography;

type Props = ProjectHomeIdentifiersProps & {
  category: string;
  sub: string;
  sub2: string;
  items: OfferedItemLookup[];
  stepId: string;
};

export const Subcategory2Group: React.FC<Props> = (props) => {
  const { category, sub, sub2, items, ...rest } = props;

  return (
    <div key={sub2} className="mb-2">
      <div id={`subcategory2-${sub2}`}>
        <Title level={4}>
          {sub} – {sub2}
        </Title>
      </div>
      {items
        .filter(
          (i) =>
            i.category === category &&
            i.subcategory === sub &&
            i.subcategory2 === sub2,
        )
        .map((item) => (
          <OfferedItemDetails
            key={item.id}
            item={item}
            {...rest}
            className="mb-2"
          />
        ))}
    </div>
  );
};
